import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Tag } from '@design-system/components/tag/tag';
import {
  faDollar,
  faGrid2Plus,
  faTag,
} from '@fortawesome/pro-regular-svg-icons';
import { sprinkles } from '@design-system/sprinkles.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Col, Row } from '@design-system/components/grid/grid';
import {
  button,
  detailItem,
  detailsContainer,
  tag,
  wrapper,
} from './MigratedToOffersModal.css';
import { HomeVM } from '../home.viewModel';

type MigratedToOffersModalProps = HomeVM['offerMigrationModal'];

const details = [
  {
    icon: faDollar,
    title: 'Price change',
    details:
      'Adjust the price of your Exclusive Subscription anytime you need.',
  },
  {
    icon: faGrid2Plus,
    title: 'Mix and match',
    details:
      'Create and sell your Programs & Extras in one subscription! Include community, livestreams, and DMs access too!',
  },
  {
    icon: faTag,
    title: 'Sell your Extras',
    details:
      'PDF, Video, Slides: Put a price tag on these and sell them individually or together!',
  },
];

export const MigratedToOffersModal = (props: MigratedToOffersModalProps) => (
  <Modal
    isOpen={props.isOpen}
    onClose={props.close}
    modalClassName="w-full md:w-[742px]"
    contentClassName="w-full h-full gap-0"
    largeTitle
    centerContent
    disableBackdropClick
  >
    <Col center gap="xl" className={wrapper}>
      <Col center gap="l">
        <Tag label="New feature" className={tag} readonly />
        <Typography variant="headline" size="large">
          Offers are here!
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          Your subscription is an offer. And all offers now have the following
          flexibility:
        </Typography>
      </Col>
      <Row gap="l" className={detailsContainer}>
        {details.map(({ icon, title, details }) => (
          <Row key={title} className={detailItem}>
            <FontAwesomeIcon
              icon={icon}
              className={sprinkles({ color: 'P-80', paddingTop: 'xs' })}
            />
            <Col className={sprinkles({ textAlign: 'left' })}>
              <Typography variant="body" size="large">
                {title}
              </Typography>
              <Typography
                className={sprinkles({ color: 'N-80' })}
                variant="body"
                size="medium"
                fontWeight="normal"
              >
                {details}
              </Typography>
            </Col>
          </Row>
        ))}
      </Row>
      <Row>
        <a
          href="https://help.playbookapp.io/en/articles/9698798-exclusive-subscription-strategy-pricing-and-packaging"
          target="_blank"
          rel="noreferrer"
        >
          <Button variant="text" color="primary" className={button}>
            Learn More
          </Button>
        </a>
        <Button color="neutral" onClick={props.redirect} className={button}>
          Go to Offers
        </Button>
      </Row>
    </Col>
  </Modal>
);
